import type { TaskSummary } from "../domain/entities";

export function taskLocationLabel(task: TaskSummary) {
  if (task.project) return `Project「${task.project.name}」`;
  if (task.area) return `Area「${task.area.name}」`;
  return ({ inbox: "Inbox", today: "Today", anytime: "Anytime", someday: "Someday", date: task.startDate ? `Upcoming ${task.startDate}` : "Upcoming" } as Record<TaskSummary["scheduleKind"], string>)[task.scheduleKind];
}

export function restorationOutcome(before: TaskSummary, restored: TaskSummary) {
  const location = taskLocationLabel(restored);
  if (before.projectId && (!restored.projectId || !restored.project)) return `The original Project no longer exists. The Task was restored safely in ${location}.`;
  if (before.headingId && !restored.headingId) return `The original Heading no longer exists. The Task was restored at the root of ${location}.`;
  if (before.areaId && !before.projectId && (!restored.areaId || !restored.area)) return `The original Area no longer exists. The Task was restored safely in ${location}.`;
  return `Restored to its original position in ${location}.`;
}
